import React from 'react';
import { DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown } from 'reactstrap';
import { useTranslator } from '@front-activerse/common-components';
import { useAppContext } from '@front-activerse/common-components';

interface ILanguageChangeProps {
  displayLangName: boolean;
}

const LanguageChange: React.FC<ILanguageChangeProps> = ({ displayLangName }) => {
  const { t, language, changeLanguage } = useTranslator();
  const {
    images: { flagEn, flagSv, flagPl, flagPt },
    consts: { ALLOWED_LANGUAGES },
  } = useAppContext();

  const handleLanguageChange = (lang: string) => {
    changeLanguage(lang);
  };

  const renderFlag = (lang: string) => {
    switch (lang) {
      case 'en-US':
        return flagEn;
      case 'sv-SE':
        return flagSv;
      case 'pl-PL':
        return flagPl;
      case 'pt-BR':
        return flagPt;
      default:
        return flagEn;
    }
  };

  if (Array.isArray(ALLOWED_LANGUAGES) && ALLOWED_LANGUAGES.length === 1) {
    return null;
  }

  return (
    <ul className="p-0 m-0">
      <UncontrolledDropdown nav>
        <DropdownToggle nav className="">
          <img
            src={renderFlag(language)}
            // className="me-1"
            width="22.5"
            height="22.5"
            alt={language}
          />{' '}
          {displayLangName && (
            <span className="d-inline-block ms-1">{t(`language/${language}`)}</span>
          )}
        </DropdownToggle>
        <DropdownMenu className="mt-2">
          {Array.isArray(ALLOWED_LANGUAGES) &&
            ALLOWED_LANGUAGES.map((lang: any) => (
              <DropdownItem key={lang} onClick={() => handleLanguageChange(lang)} className="mt-2">
                <img
                  src={renderFlag(lang)}
                  alt={lang}
                  className="me-1"
                  width="22.5"
                  height="22.5"
                />{' '}
                {t(`language/${lang}`)}
              </DropdownItem>
            ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    </ul>
  );
};

export default LanguageChange;
